import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class MtCaptchaApiService extends ApiService {
  constructor(public http: HttpClient) {
    super(http);
  }

  public validateToken(token: string): Observable<any> {
    const uri = `api/captcha/validate`;
    return this.http.post(this.directEndpoint(uri), JSON.stringify(token), {
      headers: { 'Content-Type': 'application/json' }, // eslint-disable-line
    });
  }
}
